module.exports = __webpack_public_path__ + "static/media/3 02 Tulleord Sgo-norming.66d027da.mp3";